import { CircleAlert, CircleCheck, RefreshCw } from "lucide-react";

import EntryDetails from "components/LogItem/elements/EntryDetails";
import { startCase } from "helpers/string";

const actorOf = ({ user_name }) => user_name || "The system";

// The initiator sits mid-sentence in the completion entries.
const initiatorOf = ({ user_name }) => user_name || "the system";

const hasGaps = item => (item.info.skipped_count ?? 0) > 0;

const skippedRows = ({ skipped = [], skipped_count: skippedCount = 0 }) => {
  const rows = skipped.map(record => ({
    label: `${startCase(record.object_type)} ${record.id}${
      record.event_id ? ` (event ${record.event_id})` : ""
    }`,
    value: record.reason,
  }));
  const hiddenCount = skippedCount - skipped.length;
  if (hiddenCount > 0) {
    rows.push({ label: "Not listed", value: `${hiddenCount} more records` });
  }
  return rows;
};

const completedMessage = item => {
  const { skipped_count: skippedCount = 0 } = item.info;
  const outcome = skippedCount
    ? `finished with gaps: ${skippedCount} ${
        skippedCount === 1 ? "record" : "records"
      } could not be stored`
    : "finished successfully";
  return (
    <>
      <p>
        The Swoogo sync initiated by {initiatorOf(item)} {outcome}.
      </p>
      <EntryDetails rows={skippedRows(item.info)} />
    </>
  );
};

export const SWOOGO_EVENTS = {
  swoogo_sync_started: {
    title: "Sync Started",
    icon: RefreshCw,
    message: item => <p>{actorOf(item)} started a Swoogo sync.</p>,
  },
  swoogo_sync_completed: {
    title: item =>
      hasGaps(item) ? "Sync Finished with Gaps" : "Sync Completed",
    icon: item => (hasGaps(item) ? CircleAlert : CircleCheck),
    message: completedMessage,
  },
  swoogo_sync_failed: {
    title: "Sync Failed",
    icon: CircleAlert,
    message: item => (
      <>
        <p>The Swoogo sync initiated by {initiatorOf(item)} failed.</p>
        <EntryDetails rows={[{ label: "Reason", value: item.info.error }]} />
      </>
    ),
  },
  swoogo_remove_session_registrant_failed: {
    title: "Session Removal Failed",
    icon: CircleAlert,
    message: item => (
      <>
        <p>
          {actorOf(item)} could not remove the registrant from{" "}
          {/* The task stores no name when the session is no longer stored. */}
          {item.info.session_name || "the session"}.
        </p>
        <EntryDetails rows={[{ label: "Reason", value: item.info.reason }]} />
      </>
    ),
  },
};
